import _objectSpread from "@babel/runtime/helpers/objectSpread2";
var _Info, _Checkmark;
import Checkmark from '@crehana/compass.icons.outline/Checkmark';
import Info from '@crehana/compass.icons.outline/Info';
import { TooltipWrapper } from '@crehana/compass.ui';
import { useTranslation } from '@crehana/i18n';
import { COLLAPSE_PERMISSIONS_ROLE } from "../i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PermissionsActions = function PermissionsActions(_ref) {
  var currentPermission = _ref.currentPermission,
    moduleKey = _ref.moduleKey,
    permissionKey = _ref.permissionKey;
  var can_be_edited = currentPermission.can_be_edited,
    can_be_viewed = currentPermission.can_be_viewed,
    name = currentPermission.name,
    description = currentPermission.description;
  var permissionControls = [{
    checked: can_be_edited,
    id: "".concat(moduleKey).concat(permissionKey, "-1")
  }, {
    checked: can_be_viewed && !can_be_edited,
    id: "".concat(moduleKey).concat(permissionKey, "-2")
  }, {
    checked: !can_be_edited && !can_be_viewed,
    id: "".concat(moduleKey).concat(permissionKey, "-3")
  }];
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-grid tw-grid-cols-12 tw-py-2 tw-border-t tw-border-solid tw-border-neutral-light-400 ",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-gap-1.2 tw-col-span-3 tw-font-link1 tw-px-2.4",
      children: [/*#__PURE__*/_jsx("span", {
        children: name
      }), /*#__PURE__*/_jsx(TooltipWrapper, {
        message: description || '',
        position: "right",
        children: _Info || (_Info = /*#__PURE__*/_jsx(Info, {
          className: "tw-flex tw-text-neutral-light-600",
          size: 16
        }))
      })]
    }), permissionControls.map(function (control) {
      return /*#__PURE__*/_jsx("div", {
        className: "tw-col-span-3 tw-text-center tw-m-auto tw-px-2.4",
        children: control.checked && (_Checkmark || (_Checkmark = /*#__PURE__*/_jsx(Checkmark, {
          className: "tw-text-primary-light-500",
          size: 24
        })))
      }, control.id);
    })]
  });
};
var ContentCollapseResume = function ContentCollapseResume(props) {
  var permissions = props.permissions;
  var _useTranslation = useTranslation(COLLAPSE_PERMISSIONS_ROLE),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-col-span-full tw-flex-col tw-justify-center tw-border tw-border-solid tw-border-neutral-light-400 tw-bg-neutral-light-100 tw-rounded-1.6",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "tw-grid tw-grid-cols-12 tw-items-center tw-bg-neutral-light-200 tw-rounded-t-1.6 tw-h-4.4",
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-col-span-3 tw-font-link1 tw-px-2.4",
        children: t('STEP_3_TABLE_COLUMN_1')
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-col-span-3 tw-text-center tw-font-link1 tw-px-2.4",
        children: t('STEP_3_TABLE_COLUMN_2')
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-col-span-3 tw-text-center tw-font-link1 tw-px-2.4",
        children: t('STEP_3_TABLE_COLUMN_3')
      }), /*#__PURE__*/_jsx("div", {
        className: "tw-col-span-3 tw-text-center tw-font-link1 tw-px-2.4",
        children: t('STEP_3_TABLE_COLUMN_4')
      })]
    }), permissions.map(function (permission, i) {
      return /*#__PURE__*/_jsx(PermissionsActions, _objectSpread({
        currentPermission: permission,
        permissionKey: i
      }, props), permission.id);
    })]
  });
};
export default ContentCollapseResume;